import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import Story from "./sections/Story";
import TeachingPhilosophy from "./sections/TeachingPhilosophy";
import LearningByDoing from "./sections/LearningByDoing";
import RoboticsPathway from "./sections/RoboticsPathway";
import RoboticsPathwayCopy from "./sections/RoboticsPathwayCopy";
import EquipmentAndGroupComparison from "./sections/EquipmentAndGroupComparison";
import EcosystemCopy from "./sections/EcosystemCopy";
import RobotoDifferentiators from "./sections/RobotoDifferentiators";
import EcosystemProjects from "./sections/EcosystemProjects";
import TeachingTeam from "./sections/TeachingTeam";
import Ecosystem from "./sections/Ecosystem";
import Values from "./sections/Values";
import ParentCommitments from "./sections/ParentCommitments";
import CentersCta from "./sections/CentersCta";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <Story />
      <TeachingPhilosophy />
      <LearningByDoing />
      <RoboticsPathway />
      <RoboticsPathwayCopy />
      <EquipmentAndGroupComparison />
      <EcosystemCopy />
      <RobotoDifferentiators />
      <EcosystemProjects />
      <TeachingTeam />
      <Ecosystem />
      <Values />
      <ParentCommitments />
      <CentersCta />
      <Footer />
    </div>;
}